export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-16.png?4c3023f2059d4abcfb65afe5a1d1ad52";